import CrudModule from "@/components/CrudModule";
import { MODULES } from "@/config/modules";
export default function Commissions() {
  return (
    <CrudModule module={MODULES.commissions} subtitle="Expected vs received commission, lead cost, net and chargebacks." />
  );
}
